// Weather Observation Codes – M/S Mary Jane log exercises
// Extracted from live WordPress block attributes (allships.com.au), weatherObsExercises
const weatherObsExercises = [
  {
    weatherobs_question: "Looks like the wind have picked up a bit. At 06:50, you are observing large wavelets, crest begin to break; and partly clouded sky. Sea looks to be between 0.5 to 1m in height. We increased speed just after last log entry. Still good visibility.",
    weatherobs_heading: "120",
    weatherobs_sog: "14",
    weatherobs_datetime: "06:50",
    weatherobs_log_distance: "14",
    weatherobs_total_distance: "14",
    weatherobs_wind_scale: "3",
    weatherobs_wind_direction: "SE",
    weatherobs_sea_state: "3",
    weatherobs_weather_scale: "bc",
    weatherobs_visibility: "7",
    weatherobs_barometer: "1020",
  },
  {
    weatherobs_question: "At 07:50, we have just altered our course slightly but maintaining same speed. Wind and sea conditions looks unchanged but sky is now cloudy. Still good visibility.",
    weatherobs_heading: "130",
    weatherobs_sog: "14",
    weatherobs_datetime: "07:50",
    weatherobs_log_distance: "14",
    weatherobs_total_distance: "28",
    weatherobs_wind_scale: "3",
    weatherobs_wind_direction: "SSE",
    weatherobs_sea_state: "3",
    weatherobs_weather_scale: "c",
    weatherobs_visibility: "7",
    weatherobs_barometer: "1018",
  },
  {
    weatherobs_question: "At 8:50, wind is picking up and visibility seeing moderate waves with many white horses. Waves to around 1.5 to 2m. Visibility to 4-5km and cloudy.",
    weatherobs_heading: "135",
    weatherobs_sog: "14",
    weatherobs_datetime: "08:50",
    weatherobs_log_distance: "14",
    weatherobs_total_distance: "42",
    weatherobs_wind_scale: "5",
    weatherobs_wind_direction: "S",
    weatherobs_sea_state: "4",
    weatherobs_weather_scale: "c",
    weatherobs_visibility: "6",
    weatherobs_barometer: "1015",
  },
  {
    weatherobs_question: "At 9:50, wind and sea conditions remain the same. We slowed down just after last log entry and altered our bearing as we came around headland. ",
    weatherobs_heading: "220",
    weatherobs_sog: "12",
    weatherobs_datetime: "09:50",
    weatherobs_log_distance: "12",
    weatherobs_total_distance: "54",
    weatherobs_wind_scale: "5",
    weatherobs_wind_direction: "SSE",
    weatherobs_sea_state: "4",
    weatherobs_weather_scale: "c",
    weatherobs_visibility: "6",
    weatherobs_barometer: "1018",
  },
  {
    weatherobs_question: "At 10:50, weather have cleared up with good visiblity. Clear skys with no clouds,  Smaller waves with fairly frequent white horses and waves dropped to around a metre.",
    weatherobs_heading: "210",
    weatherobs_sog: "12",
    weatherobs_datetime: "10:50",
    weatherobs_log_distance: "12",
    weatherobs_total_distance: "66",
    weatherobs_wind_scale: "4",
    weatherobs_wind_direction: "S",
    weatherobs_sea_state: "3",
    weatherobs_weather_scale: "b",
    weatherobs_visibility: "7",
    weatherobs_barometer: "1022",
  },
];

export default weatherObsExercises;
